import { firestoreQP } from 'src/utils/firebaseQP';

export const BACKOFFICE_MAINTENANCE_ROUTE = '/maintenance';

export type BackOfficeMaintenanceRuntime = {
  isBackOfficeMaintenance: boolean;
  maintenanceMessage: string;
  maintenanceLoaded: boolean;
};

export const BACKOFFICE_MAINTENANCE_FAIL_SAFE: BackOfficeMaintenanceRuntime = {
  isBackOfficeMaintenance: false,
  maintenanceMessage: '',
  maintenanceLoaded: true,
};

export function parseBackOfficeMaintenanceFromDoc(
  data: Record<string, unknown> | undefined
): Pick<BackOfficeMaintenanceRuntime, 'isBackOfficeMaintenance' | 'maintenanceMessage'> {
  const maintenance = data?.maintenance as Record<string, unknown> | undefined;

  return {
    isBackOfficeMaintenance: maintenance?.isBackOfficeMaintenance === true,
    maintenanceMessage:
      typeof maintenance?.message === 'string' ? maintenance.message : '',
  };
}

export async function fetchBackOfficeMaintenance(): Promise<BackOfficeMaintenanceRuntime> {
  try {
    const snap = await firestoreQP.collection('settings').doc('1').get();
    const parsed = parseBackOfficeMaintenanceFromDoc(
      snap.exists ? (snap.data() as Record<string, unknown>) : undefined
    );

    return {
      ...parsed,
      maintenanceLoaded: true,
    };
  } catch (error) {
    console.warn('Could not fetch back office maintenance from Firebase:', error);
    return BACKOFFICE_MAINTENANCE_FAIL_SAFE;
  }
}
